import { transformAppDetails } from '../GetDetails';
import { ServerResponseType, CreateIncidentResponseType } from './types';

export const transformAddIncidentResponse = (
  response: ServerResponseType
): CreateIncidentResponseType => {
  return {
    newIdentifier: response.identifier,
    appDetails: transformAppDetails(response),
  };
};
